import Service from 'app/services/Service'

class IntercomService extends Service {
  constructor() {
    super('/intercom')
  }

  async fetchIntercomJwt(): Promise<string | null> {
    try {
      const data = await this.post({}, '/token')
      return data
    } catch (e) {
      return null
    }
  }
}

const intercomService = new IntercomService()
export default intercomService
